import { makeVar } from '@apollo/client';

/**
 * Клиентское состояние колокольчика (ТЗ 0068).
 *
 * Почему `makeVar`, а не `useState` внутри организма: два из этих полей нужны
 * ЗА пределами панели. `open` читает звуковой хук (не пищим, когда человек и
 * так смотрит на уведомления), а `audioUnlocked` выставляет глобальный
 * слушатель первого клика по документу — он живёт вне дерева попапа.
 */
export type TNotificationsPane = 'list' | 'settings';
export type TNotificationsFilter = 'all' | 'unread';

export interface INotificationsState {
  open: boolean;
  pane: TNotificationsPane;
  filter: TNotificationsFilter;
  /**
   * Разрешил ли браузер звук В ЭТОЙ загрузке страницы.
   *
   * В `localStorage` НЕ кладём: разрешение даёт браузер, а не мы, и
   * закэшированное «да» означало бы тишину без единого объяснения — мы бы
   * считали, что звук идёт, а его нет.
   */
  audioUnlocked: boolean;
  /** «Отложить на час»: отметка времени в мс. 0 — не отложено. */
  mutedUntil: number;
}

export const defaultNotificationsState: INotificationsState = Object.freeze({
  open: false,
  pane: 'list',
  filter: 'all',
  audioUnlocked: false,
  mutedUntil: 0,
});

export const notificationsState = makeVar<INotificationsState>({
  ...defaultNotificationsState,
});
